// extracted by mini-css-extract-plugin
module.exports = {"addressModal":"CustomDeliveryModal_addressModal__mCdak","addressModalWrapper":"CustomDeliveryModal_addressModalWrapper__z6gQh"};